// @ts-nocheck

import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';

import TimerPeriodIdContainer from '../../../../components/TimerPeriodId/TimerPeriodIdContainer';
import { __ } from '../../../../i18n/l10n';
import InfoButton from '../buttons/InfoButton';

const StyledTimerContainer = styled(TimerPeriodIdContainer)`
  display: inline-block;
  text-transform: uppercase;
  padding: 0.2em;
  margin-right: 0.4em;
  min-width: 2.5em;
  text-align: center;

  ${({ theme }) => css`
    background: ${theme.grids.colors.yellow};
    color: ${theme.grids.colors.black};
  `}
`;

const Score = styled.span`
  white-space: nowrap;
  font-family: BettingPoliticaBold, sans-serif;
  margin-left: 0.2em;
`;

const Color = styled.span`
  color: ${({ $shouldColored, $isWin, $isLost, theme }) => {
    if ($shouldColored) {
      if ($isWin) {
        return theme.grids.colors.greenwin;
      }
      if ($isLost) {
        return theme.grids.colors.redlight;
      }
    }
    return '#fff';
  }};
`;

type GridsMatchGridInfoProps = {
  score1?: number;
  score2?: number;
  matchId: number;
  isWin?: boolean;
  isLost?: boolean;
  isCancelled?: boolean;
  isEnded?: boolean;
  isLive?: boolean;
  isPrematch?: boolean;
};

const GridsMatchGridInfo = ({
  score1,
  score2,
  matchId,
  isWin,
  isLost,
  isCancelled,
  isEnded,
  isLive,
  isPrematch,
}: GridsMatchGridInfoProps) => {
  const renderScore = useCallback(() => {
    return score1 !== null && score1 !== undefined && score2 !== null && score2 !== undefined ? (
      <Color $shouldColored={isEnded} $isWin={isWin} $isLost={isLost}>{`${score1} - ${score2}`}</Color>
    ) : (
      ''
    );
  }, [isEnded, isLost, isWin, score1, score2]);

  if (isCancelled) {
    return (
      <Score>
        <Color>{__('Cancelled')}</Color>
      </Score>
    );
  }
  if (isEnded) {
    return <Score>{renderScore()}</Score>;
  }
  if (isPrematch) {
    return (
      <InfoButton
        to={{
          hash: '#stats',
          state: { modal: true, matchId },
        }}
      >
        i
      </InfoButton>
    );
  }
  if (isLive) {
    return (
      <Score>
        <StyledTimerContainer matchId={matchId} isGrid />
        {renderScore()}
      </Score>
    );
  }
  return '';
};

export default GridsMatchGridInfo;
